// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import {AuthProvider} from "./AuthContext";
// import ErrorBoundary from "./ErrorBoundary";
// import {BrowserRouter as Router} from 'react-router-dom';
//
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//           <AuthProvider>
//               <ErrorBoundary>
//                   <Router>
//                   <App/>
//                   </Router>
//               </ErrorBoundary>
//           </AuthProvider>
//   </React.StrictMode>
// );
//
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js'
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import AppRoutes from './Routes';
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                {/*<AppRoutes />*/}
                <App/>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>

);
reportWebVitals();